import React from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { IconButton, Popover, MenuList, MenuItem, ListItemIcon, ListItemText, Divider } from '@mui/material'
import { SortByAlpha as SortByAlphaIcon, ArrowUpward as ArrowUpwardIcon, ArrowDownward as ArrowDownwardIcon } from '@mui/icons-material'
import { ReactComponent as CircleSortIcon } from 'assets/CircleSortIcon.svg'
import { setSortModel } from 'slices/customer/persistentCustomerDetailsLocationsSlice'
import { selectSortModel } from 'data/customer/customerDetailsLocationsSelectors'
import T from 'T'

const LocationSortPopover = () => {
  const dispatch = useDispatch()
  const persistedSortModel = useSelector(selectSortModel)
  const [sortPopoverAnchorEl, setSortPopoverAnchorEl] = React.useState(null)

  const handleSortPopoverClick = event => {
    setSortPopoverAnchorEl(event.currentTarget)
  }

  const handleSortPopoverClose = () => {
    setSortPopoverAnchorEl(null)
  }

  const handleSortField = (field, direction) => {
    const newSortModel = [
      {
        field,
        sort: direction,
      },
    ]
    dispatch(setSortModel(newSortModel))
    handleSortPopoverClose()
  }

  const handleClearSort = () => {
    const newSortModel = []
    dispatch(setSortModel(newSortModel))
    handleSortPopoverClose()
  }

  const handleSortAddressNameAsc = () => {
    handleSortField('addressName', 'asc')
  }

  const handleSortAddressNameDesc = () => {
    handleSortField('addressName', 'desc')
  }

  const handleSortFullAddressAsc = () => {
    handleSortField('fullAddress', 'asc')
  }

  const handleSortFullAddressDesc = () => {
    handleSortField('fullAddress', 'desc')
  }

  const handleClearSortClick = () => {
    handleClearSort()
  }

  const getCurrentSort = () => {
    if (persistedSortModel && persistedSortModel.length > 0) {
      const sort = persistedSortModel[0]
      if (sort.field === 'addressName' || sort.field === 'fullAddress') {
        return { field: sort.field, direction: sort.sort }
      }
    }
    return null
  }

  const isSortPopoverOpen = Boolean(sortPopoverAnchorEl)
  const currentSort = getCurrentSort()

  return (
    <>
      <IconButton
        size="small"
        onClick={handleSortPopoverClick}
        sx={{
          color: currentSort ? 'primary.main' : 'text.secondary',
          backgroundColor: currentSort ? 'action.selected' : 'transparent',
        }}
      >
        <CircleSortIcon />
      </IconButton>

      <Popover
        open={isSortPopoverOpen}
        anchorEl={sortPopoverAnchorEl}
        onClose={handleSortPopoverClose}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'right',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
      >
        <MenuList>
          <MenuItem onClick={handleSortAddressNameAsc} selected={currentSort?.field === 'addressName' && currentSort?.direction === 'asc'}>
            <ListItemIcon>
              <ArrowUpwardIcon fontSize="small" />
            </ListItemIcon>
            <ListItemText>{T.SORT_ADDRESS_NAME_AZ}</ListItemText>
          </MenuItem>

          <MenuItem
            onClick={handleSortAddressNameDesc}
            selected={currentSort?.field === 'addressName' && currentSort?.direction === 'desc'}
          >
            <ListItemIcon>
              <ArrowDownwardIcon fontSize="small" />
            </ListItemIcon>
            <ListItemText>{T.SORT_ADDRESS_NAME_ZA}</ListItemText>
          </MenuItem>

          <Divider />

          <MenuItem onClick={handleSortFullAddressAsc} selected={currentSort?.field === 'fullAddress' && currentSort?.direction === 'asc'}>
            <ListItemIcon>
              <ArrowUpwardIcon fontSize="small" />
            </ListItemIcon>
            <ListItemText>{T.SORT_FULL_ADDRESS_AZ}</ListItemText>
          </MenuItem>

          <MenuItem
            onClick={handleSortFullAddressDesc}
            selected={currentSort?.field === 'fullAddress' && currentSort?.direction === 'desc'}
          >
            <ListItemIcon>
              <ArrowDownwardIcon fontSize="small" />
            </ListItemIcon>
            <ListItemText>{T.SORT_FULL_ADDRESS_ZA}</ListItemText>
          </MenuItem>

          {currentSort && (
            <>
              <Divider />
              <MenuItem onClick={handleClearSortClick}>
                <ListItemIcon>
                  <SortByAlphaIcon fontSize="small" />
                </ListItemIcon>
                <ListItemText>{T.CLEAR_SORT}</ListItemText>
              </MenuItem>
            </>
          )}
        </MenuList>
      </Popover>
    </>
  )
}

LocationSortPopover.propTypes = {}

export default LocationSortPopover
